const errorMessages = {
  email: {
    required: "Uw e-mailadres is vereist",
    email: "Geef een geldig e-mailadres op",
  },
  password: {
    required: "Je opgegeven wachtwoord is incorrect",
    min: "Je wachtwoord moet minimaal 6 karakters lang zijn.",
    confirmed: "Je ingevulde wachtwoord komt niet overeen met je huidige",
  },
  newpass: {
    required: "Vul hier je nieuwe wachtwoord in",
    min: "Wachtwoord heeft minstens 6 tekens nodig",
    confirmed: "Dit is je huidige wachtwoord",
  },
  newpassRepeat: {
    required: "Vul hier je nieuwe wachtwoord nog een keer in",
    confirmed: "Wachtwoorden komen niet overeen",
  },
  number: {
    required: "Je Inlogcode mag alleen nummers bevatten",
    min: "Je Inlogcode moet minimaal 6 karakters lang zijn.",
  },
  userName: {
    required: "Je naam is nog niet ingevuld",
  },
  tel: {
    required: "Je nieuwe telefoonnummer is nog niet ingevuld",
    min: "Je telefoonnummer moet 10 nummers bevatten",
  },
  selectieNaam: {
    required: "Vul alsjeblieft een naam voor je selectie in",
  },
  name: {
    required: "Vul alsjeblieft jouw naam in",
  },
  textarea: {
    required: "Vul hier alsjeblieft jouw reden",
  },
  regPasswordConfirm: {
    confirmed: "Wachtwoorden komen niet overeen",
  },
};

const rulesset = {
  required: (key, value) => {
    if (!value) {
      if (errorMessages[key]?.required) {
        return errorMessages[key].required;
      } else {
        return "The " + key + " value is not valid";
      }
    }
    return;
  },

  email: (key, value) => {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!regex.test(value)) {
      if (errorMessages[key]?.email) {
        return errorMessages[key].email;
      } else {
        return key + " must be a valid email";
      }
    }
    return;
  },

  min: (key, value, minValue = 4) => {
    if (value.length < minValue) {
      if (errorMessages[key]?.min) {
        return errorMessages[key].min;
      } else {
        return key + " Must be minimum " + minValue + " character";
      }
    }
    return;
  },

  numeric: (key, value) => {
    const regex = /^\d+$/;
    if (!regex.test(value)) {
      if (errorMessages[key]?.numeric) {
        return errorMessages[key].numeric;
      } else {
        return key + " only allows digits";
      }
    }
    return;
  },

  confirmed: (key, value, compValue) => {
    if (value !== compValue) {
      if (errorMessages[key]?.confirmed) {
        return errorMessages[key].confirmed;
      } else {
        return key + " is not matched";
      }
    }
    return;
  },
};

const errorsSet = [];

const validation = (validators) => {
  if (validators) {
    const validator = Object.keys(validators);
    validator.forEach((v) => {
      let rule = Object.keys(validators[v].rule);
      let value = validators[v].value;
      rule.forEach((r) => {
        let result = "";

        if (rulesset.hasOwnProperty(r)) {
          let params = [v, value, validators[v].rule[r]];
          result = rulesset[r](...params);
        }

        if (result) {
          if (errorsSet.hasOwnProperty(v)) {
            errorsSet[v].push(result);
          } else {
            errorsSet[v] = [];
            errorsSet[v].push(result);
          }
        }
      });
    });

    if (Object.keys(errorsSet).length !== 0) {
      return false;
    }
    return true;
  }
  return true;
};

const errors = {
  has: (key) => {
    if (errorsSet.hasOwnProperty(key)) {
      return true;
    }
    return false;
  },
  first: (key) => {
    return errorsSet[key][0];
  },
};

export { validation, errors };
